import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './routers'
import message from '@/utils/message.js'
import './styles/main.css'

Vue.config.productionTip = false
Vue.prototype.$message = message

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
